
 document.addEventListener('DOMContentLoaded', function() {

  // Get the hidden variant ID

  const variantSkuEl = document.querySelector('.sku-watch');

  if (!variantSkuEl) return;

  // Select the variant metafield display element

  let variantMetafieldGroupTxtDisplay = document.querySelector('.variant-metafield-grouptxt');
  let variantMetafieldSpecDisplay = document.querySelector('.variant-metafield-specs');
  console.log(variantMetafieldGroupTxtDisplay)

  const variantSelect = document.querySelector('.variant-picker');

    updateMetafieldDisplay = () => {
    const selectedVariantId = variantSkuEl.dataset.variantId;

    if (selectedVariantId) {
    // Select the hidden variant metafields correct element
     const metafieldTextValue = document.getElementById(`${selectedVariantId}-groupTxt`);
     const metafieldSpecsValue = document.getElementById(`${selectedVariantId}-specs`);

      variantMetafieldSpecDisplay.innerHTML = "";
      variantMetafieldGroupTxtDisplay.innerHTML = "";
      variantMetafieldGroupTxtDisplay.innerHTML = metafieldTextValue.innerHTML;
      variantMetafieldSpecDisplay.innerHTML = metafieldSpecsValue.innerHTML;


    }

  };

     

  // Create an observer instance linked to the callback function

  const observer = new MutationObserver(updateMetafieldDisplay);

  // Start observing the target node for configured mutations

  observer.observe(variantSkuEl, { attributes: true, attributeFilter: ['data-variant-id'] });

  // Initial update on page load

  updateMetafieldDisplay();

});
